module.exports = "<div class=row> <div class=col-xs-12> <h3 translate>Create Rules / Warnings</h3> </div> </div> <div class=\"row create-buttons\"> <div class=col-xs-4 ng-repeat=\"areaType in $ctrl.areaTypes\"> <button type=button class=\"btn btn-white-icon-right\" ng-click=$ctrl.createProtectionArea(areaType) ng-disabled=!$ctrl.canCreateArea> <span class=icon-add></span> <span>{{ ::areaType | appTranslateEnum:'protection_area_type' }}</span> </button> </div> </div> <app-searchfilters-area></app-searchfilters-area> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/home/area/partial.html
// module id = 412
// module chunks = 0